import styled from "styled-components";

export const ChartCardStyles = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .chart-card {
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.02);
    border-radius: ${({ theme }) => theme.radius[12]};
    overflow: hidden;
  }

  .chart-card__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    padding: 18px 20px 6px;
  }

  .chart-card__heading {
    min-width: 0;
  }

  .chart-card__title {
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.1px;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .chart-card__subtitle {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    margin-top: 4px;
    line-height: 16px;
  }

  .chart-card__action {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .chart-card__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .chart-card__body--padded {
    padding: 6px 20px 20px;
  }
  .chart-card__body--flush {
    padding: 0;
  }
`;
